import { Avatar, Card, Flex, Typography } from "antd";
import React from "react";
import "./PromptMessage.scss";

const { Title, Paragraph, Link } = Typography;

// Current implementation with payload structure
const PromptMessage = ({ msg, className }) => {
  const { message, file } = msg;

  // Future implementation with additional payload fields (commented out)
  /*
  const PromptMessage = ({ message }) => {
    const { msg_id, sender, text, timestamp, file } = message;
  */

  return (
    <Card className={className} >
      <Flex className="promp_box">
        <Flex className="promp_suggest" vertical>
          <Title level={2} className="title_levelTwo">
            {message || "No prompt provided"}
            {/* Future implementation */}
            {/* {text || "No prompt provided"} */}
          </Title>
          {file && (
            <Paragraph>
              File:{" "}
              <Link
                href={URL.createObjectURL(file)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {file.name}
              </Link>
            </Paragraph>
          )}
          {/* Future implementation: Display additional payload fields */}
          {/* <Paragraph>
            Message ID: {msg_id}<br />
            Sender: {sender}<br />
            Timestamp: {new Date(timestamp).toLocaleString()}
          </Paragraph> */}
        </Flex>
        <Flex className="user_profile">
          <Avatar src="https://i.pravatar" />
        </Flex>
      </Flex>
    </Card>
  );
};

export default PromptMessage;
